import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { getPeriodSummary, isOvertimePeriod } from "../utils/context-utils";
import { isOvertimeTimed } from "../utils/overtime-utils";

export default class StartDrive extends Fragment {
    constructor(startTime) {
        super();

        this.code = "DRIVE";
        this.startTime = startTime; // {period: 1, milliseconds: 72000 }

        this.requiredData = [
            {
                name: "startTime",
                type: FragmentDataType.TimeAndPeriod,
                displayName: "Drive Start",
                title: "Drive Start",
                subtitle: () => "Set the time that the drive started",
                isEditable: true
            }
        ];
    }

    summarize(summaryContext, stringifier, play) {
        const { homeTeam, awayTeam, homeTeamHasPossession, gameConfig } =
            summaryContext;
        const possessionTeam = homeTeamHasPossession ? homeTeam : awayTeam;
        const maxPeriods = gameConfig.general.periodsInRegulation;
        const { milliseconds, period } = this.startTime || {};
        const { period: normalizedPeriod, abbreviation } = getPeriodSummary(
            period,
            maxPeriods
        );

        let time = ` at ${stringifier.milisecondsToMMSS(milliseconds)}`;
        // Overtime is timed only while OT Time Control is on (PSTATS-1268).
        if (
            isOvertimePeriod(period, maxPeriods) &&
            !isOvertimeTimed(gameConfig)
        ) {
            time = "";
        }

        const message = `${
            possessionTeam.teamName
        } starts a drive${time} - ${stringifier.ordinalSuffix(
            normalizedPeriod
        )} ${abbreviation}`;

        return new FragmentSummary(message, "Start of Drive:");
    }

    updateSummaryContext(summaryContext) {
        summaryContext.sopPrinted = true;
        summaryContext.eopPrinted = true;
    }

    getTimeAndPeriod() {
        return this.startTime;
    }
}
